import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";

class O {
  gatewayId!: number;
  // Null when the device itself was DRAFTED (never an official row) and got hard-deleted
  // along with its cancelled draft, rather than reverted to its official state.
  deviceId?: number | null;
  updateTs?: string;
}

class I {
  gatewayId!: number;
  deviceId!: number;
}

export class CancelDevicePendingConfigCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(GatewayPendingConfigOPEEnum.CancelDevicePendingConfig);
    this.i = new I();
    this.o = new O();
  }
}
